import { useOkeFrame } from "@adamlip/okeoke.client.fastpay"
import { Button } from "@heroui/react"
import LoadSvg from "components/LoadSvg-v2"
import { useState } from "react"
import ActivateInstrunctionsModal from "views/RegisterDevice/ActivateInstrunctionsModal"

function Welcome({ activeScreen, setActiveScreen, requestCode, activateDemo }) {

  const { sendMessageToWebView, frameType } = useOkeFrame()
  const exitApp = () => {
    sendMessageToWebView({ action: "exitApp" })
  }
  
  const [isOpen, setIsOpen] = useState(false)

  if (activeScreen !== "welcome") return null

  return (
    <div className="hiddenOpacity appear device-login-welcome">
      <ActivateInstrunctionsModal isOpen={isOpen} setIsOpen={setIsOpen} requestCode={requestCode} />
      <div>
        <img src="https://cdn.okeoke.io/global/barsoft/Barsoft%20logo%20logo+text.svg" alt="logo" />
      </div>
      <div className="p-6 text-3xl text-center">
        Üdvözlünk a BarSoft rendszerében!
      </div>
      <div className="font-bold text-xl mb-6">Rendelkezel már üzlettel a BarSoft rendszerében?</div>
      <div className="flex flex-col gap-6 w-full">
        <Button 
          onPress={() => setIsOpen(true)} 
          fullWidth 
          color="primary" 
          className="font-bold"
          size="lg"
        >
          {`Igen, aktiválom ${requestCode != null && requestCode !== "" ? "(" + requestCode + ")" : ""}`}
        </Button>
        <Button 
          color="warning" 
          variant="flat" 
          className="font-bold" 
          size="lg" 
          onPress={() => setActiveScreen("reg-step1")}
        >
          Még nincs üzletem, regisztrálok
        </Button>
        <Button 
          color="warning" 
          className="font-bold" 
          variant="light" 
          size="lg" 
          onPress={() => activateDemo()}
        >
          Kipróbálom demo módban
        </Button>
      </div>

      {frameType === "okeElectron" && (
        <div className="btn exit-btn" onClick={exitApp}>
          <LoadSvg name="exit" />
        </div>
      )}
    </div>
  )
}
export default Welcome
